import { render, staticRenderFns } from "./SymbolSearch.vue?vue&type=template&id=d4a83806"
import script from "./SymbolSearch.vue?vue&type=script&lang=js"
export * from "./SymbolSearch.vue?vue&type=script&lang=js"
import style0 from "./SymbolSearch.vue?vue&type=style&index=0&id=d4a83806&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SymbolSearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports